import { render } from "./2fa.vue?vue&type=template&id=05e1e098&scoped=true"
import script from "./2fa.vue?vue&type=script&lang=js"
export * from "./2fa.vue?vue&type=script&lang=js"

import "./2fa.vue?vue&type=style&index=0&id=05e1e098&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e1e098"]])

export default __exports__